import { Mail, Phone, Instagram } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";
import { useLang } from "./LangContext";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_prodimmo-media/artifacts/rb17en5i_logo_prodimmo-removebg-preview.png";

const sectionIds = ["apropos", "prestations", "portfolio", "processus", "tarifs", "faq", "contact"];

export default function Footer() {
  const { t } = useLang();
  const navigate = useNavigate();
  const location = useLocation();
  const navLabels = [t.nav.apropos, t.nav.prestations, t.nav.portfolio, t.nav.processus, t.nav.tarifs, t.nav.faq, t.nav.contact];

  const handleNavClick = (e, id) => {
    e.preventDefault();
    if (location.pathname !== "/") {
      navigate(`/#${id}`);
    } else {
      document.querySelector(`#${id}`)?.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer data-testid="footer" className="bg-[#0F172A] text-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-3 gap-12">
          <div className="flex flex-col items-start">
            <img src={LOGO_URL} alt="Prodimmo" className="h-12 mb-2" />
            <p className="text-white text-lg font-semibold mb-3" style={{ fontFamily: 'Outfit' }}>Prodimmo</p>
            <p className="text-slate-400 text-sm leading-relaxed max-w-xs">{t.footer.desc}</p>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-slate-300 mb-4" style={{ fontFamily: 'Outfit' }}>
              {t.footer.navigation}
            </h4>
            <nav className="space-y-2">
              {sectionIds.map((id, i) => (
                <a
                  key={id}
                  href={`#${id}`}
                  className="block text-slate-400 hover:text-[#73B5E2] text-sm transition-colors"
                  onClick={(e) => handleNavClick(e, id)}
                >
                  {navLabels[i]}
                </a>
              ))}
            </nav>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-slate-300 mb-4" style={{ fontFamily: 'Outfit' }}>
              {t.footer.contact}
            </h4>
            <div className="space-y-3">
              <a href="mailto:contact@prodimmo.ch" className="flex items-center gap-3 text-slate-400 hover:text-[#73B5E2] text-sm transition-colors">
                <Mail className="w-4 h-4" /> contact@prodimmo.ch
              </a>
              <a href="tel:+41794595160" className="flex items-center gap-3 text-slate-400 hover:text-[#73B5E2] text-sm transition-colors">
                <Phone className="w-4 h-4" /> +41 79 459 51 60
              </a>
              <a href="https://www.instagram.com/prodimmo" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-slate-400 hover:text-[#73B5E2] text-sm transition-colors">
                <Instagram className="w-4 h-4" /> @prodimmo
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-slate-800 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-500 text-xs">&copy; {new Date().getFullYear()} Prodimmo. {t.footer.rights}</p>
          <p className="text-slate-500 text-xs">{t.footer.tagline}</p>
        </div>
      </div>
    </footer>
  );
}
